import { Component, Injector, OnInit } from '@angular/core';
import { UnlicenseduserserviceService } from '../../main-layout/unlicenseduser/unlicenseduserservice.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import Swal from 'sweetalert2';
import { VALIDATION_PATTERNS } from '../../utility/validation-patterns';
import { BaseClass } from '../../utility/baseClass';
import { Utilityservice } from '../../utility/utilityservice.service';
@Component({
  selector: 'app-unlicensedusermodal',
  templateUrl: './unlicensedusermodal.component.html',
  styleUrls: ['./unlicensedusermodal.component.css']
})
export class UnlicensedusermodalComponent extends BaseClass implements OnInit {
  userDetails: any = {}
  saveTitle = 'Add'
  isEdit: boolean = false;
  unlicensedUserForm: FormGroup;
  userid = null;
  onlyView: any;
  newuser: any;
  newuserupdate: any;
  filterproductdata: Array<any> = [];
  selectedProduct = [];
  deleteFlag: string;
  activeFlag = [
    {
      'labelname': 'Active',
      'value': 'Y'
    },
    {
      'labelname': 'Inactive',
      'value': 'N'
    }
  ]

  userType = [
    { labelname: 'Unlicensed External User', value: 'E' },
    { labelname: 'Unlicensed Internal User', value: 'I' }
  ];

  CSRFToken = "";
  constructor(
    private UnlicensedusermasterService: UnlicenseduserserviceService,
    private formBuilder: FormBuilder, 
    public router: Router,
    public ref: DynamicDialogRef,
    public override  injector: Injector,private utilityservice: Utilityservice,
    public config: DynamicDialogConfig
  ) {
    super(injector);
    const dataFromParent = this.config.data;
    this.deleteFlag = dataFromParent.deleteFlag;
    this.gettoken();
    if (dataFromParent?.title == 'Modify Unlicensed User') {
      this.saveTitle = 'Modify'
      this.isEdit = true;
      this.userDetails = dataFromParent.datas
    }
  }


  patchValueForms(data) {
    this.userid = data[0].userid;
    this.unlicensedUserForm.patchValue({ 'userid': data[0].userid });
    this.unlicensedUserForm.patchValue({ 'firstname': data[0].firstname });
    this.unlicensedUserForm.patchValue({ 'lastname': data[0].lastname });
    this.unlicensedUserForm.patchValue({ 'productName': data[0].productinitial });
    this.unlicensedUserForm.patchValue({ 'email': data[0].emailaddr });
    this.unlicensedUserForm.patchValue({ 'activeFlag': data[0].activeflag });
    this.unlicensedUserForm.patchValue({ 'userType': data[0].int_extflag });

  }

  getData() {
    if (this.userDetails.length !== undefined) {
      this.patchValueForms(this.userDetails)
    }

  }

  onSelectProduct(selectedIds) {
    this.selectedProduct = [];
    this.selectedProduct.push(selectedIds.map(e => { return { productid: e.productid } }));
  }

  addUser() {
    const productids = this.selectedProduct[0];
    const payload = {
      firstname: this.unlicensedUserForm.get('firstname').value,
      lastname: this.unlicensedUserForm.get('lastname').value,
      email: this.unlicensedUserForm.get('email').value,
      usertype: this.unlicensedUserForm.get('userType').value,
      csrftoken: this.CSRFToken,
    };
    if (this.saveTitle === 'Modify') {
      payload['productids'] = this.unlicensedUserForm.get('productid').value;
      this.modifyUser(payload);
    } else {

      if (this.unlicensedUserForm.invalid) {
        this.validateAllFormFields(this.unlicensedUserForm);
      } else {
        payload['productids'] = productids.map((product: any) => product.productid);
        Swal.fire({
          title: "Do you want to save the changes?",
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: "Save",
          denyButtonText: `Don't Save`,
        }).then((value) => {
          if (value.isConfirmed) {
            this.UnlicensedusermasterService.addUser(payload).subscribe({
              next: (data) => {
                this.newuser = data;
                if (this.newuser.response === 'exist') {
                  Swal.fire("User already exists!", "", "error").then(() => { });
                } else if (this.newuser.response === 'usermaster') {
                  Swal.fire("Email address already exists in user master.", "", "error").then(() => { });
                } else {
                  Swal.fire("Unlicensed User added successfully!", "", "success").then(() => {
                    this.ref.close();
                  });
                }
              },
              error: (error) => {
                if(error.error.response == 'html') {
                  Swal.fire("The data you entered contains HTML or JavaScript code, which is not allowed. Please remove the HTML or JavaScript content and try again.", "", "error").then(result => {
                                })
                              }       
                  else{
                Swal.fire({
                  title: "Error Saving User",
                  text: error.error.message || "An unexpected error occurred.",
                  icon: "error",
                });}
              },
            });
          } else if (value.isDenied) {
            Swal.fire("Changes are not saved", "", "info").then(() => {
              this.ref.close();
            });
          }
        });
      }
    }
  }

  ngOnInit() {
    this.formInitiliaze();
    this.getData();
    if (this.userDetails.length > 0) {
      this.unlicensedUserForm.patchValue({
        'userid': this.userDetails[0].userid,
        'firstname': this.userDetails[0].firstname,
        'lastname': this.userDetails[0].lastname,
        'productName': this.userDetails[0].productinitial,
        'email': this.userDetails[0].emailaddr,
        'activeFlag': this.userDetails[0].activeflag,
        'userType': this.userDetails[0].int_extflag,
        'productid': this.userDetails[0].productid,
      });
      this.selectedProduct = [this.userDetails[0].productid];
    } else {
      this.UnlicensedusermasterService.getproducts().subscribe((data: any) => {
        this.filterproductdata = data;
        if (this.userDetails.length > 0) {
          const productid = this.utilityservice.stringFromNumArray(this.userDetails[0].productid);
          this.selectedProduct = productid.map(id => this.filterproductdata.find(item => item.productid === id));
          this.unlicensedUserForm.patchValue({ 'productid': this.selectedProduct });
        }
      });
    }

    if (this.deleteFlag === 'N') {
      this.unlicensedUserForm.get('activeFlag').disable();
    }

    if (this.saveTitle === 'Modify') {
      this.unlicensedUserForm.get('productName').disable();
    }
  }


  formInitiliaze() {
    this.unlicensedUserForm = this.formBuilder.group({
      firstname: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(100),
        Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT),
        Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),
        Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC_NOTALLOW)])],
      lastname: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(100),
        Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT),
        Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),
        Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC_NOTALLOW)])],
      email: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(100),
        Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT),
        Validators.pattern(VALIDATION_PATTERNS.EMAIL),
        Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),
        Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC_NOTALLOW)])],

      activeFlag: [''],
      productName: [''],
      productid: ['', Validators.required],
      userType: ['', Validators.required],
    })
    if (this.isEdit === true) {
      this.unlicensedUserForm.get('activeFlag').setValidators(Validators.required);
    }
  }

  public validation_message = {
    firstname: [
      { type: 'required', message: 'First Name is required' },
      { type: 'SPACERISTRICT', message: 'Space is not allowed at the beginning or end' },
      { type: 'NOTALLOW_SPECIAL_CHAR', message: 'Special character not allowed ( % and \' ).' },
      { type: 'placeholder', message: 'Enter First Name' },
      { type: 'maxlength', message: 'Maximum length exceeded' },
      { type: 'ONLYNUMERIC_NOTALLOW', message: 'Only numeric not allowed' }
    ],
    lastname: [
      { type: 'required', message: 'Last Name is required' },
      { type: 'SPACERISTRICT', message: 'Space is not allowed at the beginning or end' },
      { type: 'NOTALLOW_SPECIAL_CHAR', message: 'Special character not allowed ( % and \' ).' },
      { type: 'placeholder', message: 'Enter Last Name' },
      { type: 'maxlength', message: 'Maximum length exceeded' },
      { type: 'ONLYNUMERIC_NOTALLOW', message: 'Only numeric not allowed' }
    ],
    email: [
      { type: 'required', message: 'Email is required' },
      { type: 'SPACERISTRICT', message: 'Space is not allowed at the beginning or end' },
      { type: 'NOTALLOW_SPECIAL_CHAR', message: 'Special character not allowed ( % and \' ).' },
      { type: 'placeholder', message: 'Enter Email' },
      { type: 'EMAIL', message: 'Invalid email format' },
      { type: 'maxlength', message: 'Maximum length exceeded' },
      { type: 'ONLYNUMERIC_NOTALLOW', message: 'Only numeric not allowed' }
    ],
    productid: [
      { type: 'required', message: 'Product is required' },],
    userType: [
      { type: 'required', message: 'User Type is required' }],
  };

  modifyUser(data: any) {

    data["userid"] = this.userid;
    data["activeFlag"] = this.unlicensedUserForm.get('activeFlag').value;
    if (this.unlicensedUserForm.invalid) {
      this.validateAllFormFields(this.unlicensedUserForm);
    } else {
      Swal.fire({
        title: "Do you want to save the changes?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Save",
        denyButtonText: `Don't Save`,
      }).then((value) => {
        if (value.isConfirmed) {
          this.UnlicensedusermasterService.modifyUser(data).subscribe({
            next: (response) => {
              this.newuserupdate = response;
              if (this.newuserupdate.response === 'exist') {
                Swal.fire("User already exists!", "", "error").then(() => { });
              } else if (this.newuserupdate.response === 'usermaster') {
                Swal.fire("Email address already exists in user master.", "", "error").then(() => { });
              } else {
                Swal.fire("Unlicensed User modified successfully!", "", "success").then(() => {
                  this.ref.close();
                });
              }
            },
            error: (error) => {
              if(error.error.response == 'html') {
                  Swal.fire("The data you entered contains HTML or JavaScript code, which is not allowed. Please remove the HTML or JavaScript content and try again.", "", "error").then(result => {
                                })
                              }       
                  else{
              Swal.fire({
                title: "Error Saving User",
                text: error.error.message || "An unexpected error occurred.",
                icon: "error",
              });}
            },
          });
        } else if (value.isDenied) {
          Swal.fire("Changes are not saved", "", "info");
          this.ref.close();
        }
      });
    }
  }

  getSelectedProductTooltip(): string {
    const selectedProducts = this.unlicensedUserForm.get('productid')?.value;
    if (selectedProducts && selectedProducts.length > 0) {
      return selectedProducts.map(product => product.productinitial).join(', ');
    }

    return 'No product selected';
  }
  gettoken() {
      this.CSRFToken = '';
      this.utilityservice.getCSRFtoken().subscribe(res => {
        this.CSRFToken = res.csrf;
      }, error => {
        Swal.fire(error.error.message, '', 'error');
      });
    }
}
